<template>
    <v-container container--fluid>
        <v-layout row wrap align-center justify-space-around class="pb-2 pt-8 px-3 mx-auto">
            <v-flex xs12 class="text-left">
                <v-row>
                    <v-col cols="12" sm="12" md="12" class="" order="2" order-sm="1">
                        <v-row>
                            <v-col class="pa-1 mb-2 d-flex justify-start" cols="12" sm="auto" md="auto">
                                <h1 class="grey--text lighten-3 mr-2 align-self-center">
                                    Categories
                                    <v-btn @click="clearCategoryVenueSelection()" color="primary" height="56" class="ml-2 d-sm-none"> <v-icon left>restore</v-icon>RESET </v-btn>
                                </h1>
                            </v-col>
                            <v-col class="pa-1 mb-2 d-flex justify-start" cols="12" sm="5" md="5">
                                <v-autocomplete
                                    class=""
                                    hide-details
                                    :loading="productsStatus"
                                    :items="categories_list"
                                    item-text="category_name"
                                    item-value="category_id"
                                    label="Select Product Category"
                                    outlined
                                    @input="updateProductsList"
                                    v-model="category"
                                ></v-autocomplete>
                                <v-btn @click="clearCategoryVenueSelection()" color="primary" height="56" class="ml-2 d-none d-sm-inline">
                                    <v-icon left>restore</v-icon>RESET
                                </v-btn>
                            </v-col>
                            <v-col class="pa-1 mb-2 d-flex justify-start" cols="12" sm="auto" md="auto">
                                <h1 class="grey--text lighten-3 mr-2 align-self-center">
                                    Venues
                                    <v-btn @click="noVenueSelection()" color="primary" height="56" class="ml-2 d-sm-none"> <v-icon left>visibility</v-icon>VIEW ALL </v-btn>
                                </h1>
                            </v-col>
                            <v-col class="pa-1 mb-2 d-flex justify-start" cols="12" sm="3" md="4">
                                <v-autocomplete
                                    class=""
                                    hide-details
                                    :loading="productsStatus"
                                    :items="venues_list"
                                    item-text="venue_name"
                                    item-value="venue_id"
                                    label="Select Venue"
                                    outlined
                                    @input="updateProductsList"
                                    v-model="venue"
                                ></v-autocomplete>
                                <v-btn @click="noVenueSelection()" color="primary" height="56" class="ml-2 d-none d-sm-inline"> <v-icon left>visibility</v-icon>VIEW ALL </v-btn>
                            </v-col>
                        </v-row>
                        <v-divider class="my-6" v-if="products_list.length > 0"></v-divider>
                        <v-row v-if="products_list.length > 0">
                            <v-col class="pa-1 mb-4 d-flex justify-start" cols="12" v-if="products_list.length > 0">
                                <h1 class="grey--text lighten-3 align-self-center">Products</h1>
                            </v-col>
                            <v-col class="pa-1" cols="12" sm="12" md="6" lg="6" v-for="(product, index) in products_list" :key="index">
                                <v-card class="mx-auto" max-width="680" height="100%" rounded raised>
                                    <v-list three-line>
                                        <v-list-item>
                                            <v-list-item-content>
                                                <div class="product-overline overline mb-4">{{ product.category.category_name }}</div>
                                                <v-list-item-title class="headline mb-1">{{ product.product_name }}</v-list-item-title>
                                                <v-list-item-subtitle class="secondary--text text--darken-4"
                                                    ><v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">monetization_on</v-icon
                                                    >{{ product.product_price | currency }} &nbsp; - &nbsp;
                                                    <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">group</v-icon
                                                    >{{ productAvailableQtyInCart(product) | pluralize("Available", { includeNumber: true }) }}
                                                    <span v-if="product.venue.venue_name"
                                                        >&nbsp; - &nbsp;<v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">location_on</v-icon
                                                        >{{ product.venue.venue_name }}</span
                                                    >
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle class="secondary--text text--darken-4 mt-1" v-if="product.product_date_start">
                                                    <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">event_note</v-icon
                                                    >{{ product.product_date_start | moment("DD/MM/YYYY") }}
                                                    <span v-if="product.product_date_end"><b>TO</b> {{ product.product_date_end | moment("DD/MM/YYYY") }}</span>
                                                    <span class="secondary--text text--darken-4 mt-1" v-if="product.product_time_start">
                                                        &nbsp; - &nbsp;<v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">schedule</v-icon
                                                        >{{ `${product.product_date_start.slice(0, -11)} ${product.product_time_start}` | moment("hh:mm A") }}
                                                        <span v-if="product.product_time_end"
                                                            ><b>TO</b> {{ `${product.product_date_start.slice(0, -11)} ${product.product_time_end}` | moment("hh:mm A") }}</span
                                                        >
                                                    </span>
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    class="primary--text text--darken-4 mt-1"
                                                    :class="product.product_date_start ? '' : 'pb-0'"
                                                    v-html="showVoucherEligibility(product.product_voucher_eligible)"
                                                ></v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    class="primary--text text--darken-4 mt-1"
                                                    :class="product.product_date_start ? '' : 'pb-4'"
                                                    v-html="showAttendeeEligibility(product.product_no_attendee)"
                                                ></v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-avatar tile size="80" color="primary">
                                                <v-img v-if="product.product_cover" :src="product.product_cover" :alt="product.product_name" cover></v-img>
                                            </v-list-item-avatar>
                                        </v-list-item>
                                        <v-list-item three-line class="line-clamp-4">
                                            <v-list-item-content class="align-start">
                                                <v-list-item-subtitle>{{ htmlDecode(product.product_description) }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>

                                    <v-card-actions>
                                        <v-btn
                                            :disabled="productAvailableQtyInCart(product) <= 0 || !isBookable(product)"
                                            v-if="showAddBtn && !productSoldOut(product)"
                                            color="primary lighten-1"
                                            class="px-2 py-1"
                                            small
                                            @click.native="addProduct(product)"
                                        >
                                            <v-icon left small>shopping_cart</v-icon>Add To Cart
                                        </v-btn>
                                        <v-btn v-if="productSoldOut(product)" color="primary lighten-1" small outlined> <v-icon left small>not_interested</v-icon>Sold Out </v-btn>
                                        <v-btn
                                            v-if="!showAddBtn && !productSoldOut(product)"
                                            small
                                            class="ma-2 primary--text"
                                            color="grey lighten-3"
                                            :to="{ name: 'products', query: { category: category } }"
                                        >
                                            Sign In<v-icon dark right>launch</v-icon>
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="dialog[index]" scrollable max-width="600">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn color="secondary lighten-1" class="px-2 py-1" small v-bind="attrs" v-on="on">
                                                    <v-icon left small>loupe</v-icon>Show Details
                                                </v-btn>
                                            </template>
                                            <v-card>
                                                <v-card-title class="headline grey lighten-2" primary-title>{{ product.product_name }}</v-card-title>
                                                <v-card-text class="pa-2" style="max-height: 440px !important;">
                                                    <div class="secondary--text text--darken-4">
                                                        <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">monetization_on</v-icon
                                                        >{{ product.product_price | currency }} &nbsp; - &nbsp;
                                                        <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">group</v-icon
                                                        >{{ productAvailableQtyInCart(product) | pluralize("Available", { includeNumber: true }) }}
                                                        <span v-if="product.venue.venue_name"
                                                            >&nbsp; - &nbsp;<v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">location_on</v-icon
                                                            >{{ product.venue.venue_name }}</span
                                                        >
                                                    </div>
                                                    <div class="secondary--text text--darken-4" v-if="product.product_date_start">
                                                        <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">event_note</v-icon
                                                        >{{ product.product_date_start | moment("DD/MM/YYYY") }}
                                                        <span v-if="product.product_date_end"><b>TO</b> {{ product.product_date_end | moment("DD/MM/YYYY") }}</span
                                                        >&nbsp; - &nbsp;
                                                        <span class="secondary--text text--darken-4 mt-1" v-if="product.product_time_start">
                                                            <v-icon left small color="secondary darken-4" size="18" style="margin-top: -2px;">schedule</v-icon
                                                            >{{ `${product.product_date_start.slice(0, -11)} ${product.product_time_start}` | moment("hh:mm A") }}
                                                            <span v-if="product.product_time_end"
                                                                ><b>TO</b> {{ `${product.product_date_start.slice(0, -11)} ${product.product_time_end}` | moment("hh:mm A") }}</span
                                                            >
                                                        </span>
                                                    </div>
                                                    <div class="primary--text text--darken-4" v-html="showVoucherEligibility(product.product_voucher_eligible)"></div>
                                                    <div class="primary--text text--darken-4" v-html="showAttendeeEligibility(product.product_no_attendee)"></div>
                                                    <v-divider class="my-2"></v-divider>
                                                    <span style="white-space: pre-wrap;" v-html="product.product_description"></span>
                                                </v-card-text>
                                                <v-card-actions class="grey lighten-2">
                                                    <v-btn color="error" text @click="dialog[index] = false">Close</v-btn>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                        :disabled="productAvailableQtyInCart(product) <= 0 || !isBookable(product)"
                                                        v-if="showAddBtn && !productSoldOut(product)"
                                                        color="primary lighten-1"
                                                        class="px-2 py-1"
                                                        small
                                                        @click.native.stop="
                                                            dialog[index] = false;
                                                            addProduct(product);
                                                        "
                                                        ><v-icon left small>shopping_cart</v-icon>Add To Cart
                                                    </v-btn>
                                                    <v-btn v-if="productSoldOut(product)" color="primary lighten-1" small outlined
                                                        ><v-icon left small>not_interested</v-icon>Sold Out
                                                    </v-btn>

                                                    <v-btn
                                                        v-if="!showAddBtn && !productSoldOut(product)"
                                                        small
                                                        class="ma-2 primary--text"
                                                        color="grey lighten-3"
                                                        :to="{ name: 'products', query: { category: category } }"
                                                    >
                                                        Sign In<v-icon dark right>launch</v-icon>
                                                    </v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-card-actions>
                                </v-card>
                            </v-col>
                        </v-row>
                        <v-row no-gutters class="justify-center" v-if="(products_list.length == 0 || categories_list.length == 0) && $route.query.category">
                            <v-col cols="12" sm="6" class="mt-6">
                                <v-alert color="secondary" style="font-size: 18px;" dense outlined text type="info">No products are currently available please check website for release dates.</v-alert>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import store from "./_store";
// import moment from 'moment';

export default {
    name: "ProductModule",
    props: ['orig'],
    components: {
        //
    },
    $_veeValidate: {
        validator: "new",
    },
    data: () => ({
        category: null,
        venue: null,
        dialog: {},
        products_list: {},
        categories_list: [],
        venues_list: [],
    }),
    computed: {
        showCartSideBar: {
            get() {
                return this.$store.getters["product/showCart"];
            },
            set(v) {
                this.$store.dispatch("product/showCartState", v);
            },
        },
        products() {
            return this.$store.getters["product/products"];
        },
        venues() {
            return this.$store.getters["product/venues"];
        },
        categories() {
            return this.$store.getters["product/categories"];
        },
        productsStatus() {
            return "success" != this.$store.getters["product/productsStatus"];
        },
        isBookable() {
            return this.$store.getters["product/isBookable"];
        },
        productAvailableQtyInCart() {
            return this.$store.getters["product/productAvailableQtyInCart"];
        },
        showAddBtn() {
            return this.$store.getters["auth/isAuthenticated"];
        },
    },
    methods: {
        htmlDecode(html) {
            let txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value.replace(/<[^>]+>/g, "");
        },
        toggleShowCart() {
            this.$store.dispatch("product/showCartState", !this.showCartSideBar);
        },
        productSoldOut(product) {
            if (product.product_quantity > product.product_booked) {
                return false;
            }

            return true;
        },
        updateProductsList() {
            let _self = this;

            this.products_list = this.products.filter(function(product) {
                if (_self.venue) {
                    return product.product_category_id === _self.category && product.product_venue_id === _self.venue;
                }

                return product.product_category_id === _self.category;
            });
        },
        updateCategoriesList(category_id) {
            if (!_.isUndefined(category_id)) {
                this.categories_list = this.categories.filter(function(category) {
                    return category.category_id === category_id || category.parent_id === category_id;
                });
            }
        },
        addProduct(product) {
            window.scroll(0, 0);
            this.$store.dispatch("product/addProductToCart", product);
        },
        checkout() {
            this.$router.push({ name: "checkout" });
        },
        clearCategoryVenueSelection() {
            this.category = null;
            this.venue = null;
            this.categories_list = this.categories;
            this.venues_list = this.venues;
            this.products_list = {};
        },
        noVenueSelection() {
            let _self = this;
            this.venue = null;

            this.products_list = this.products.filter(function(product) {
                return product.product_category_id === _self.category;
            });
        },
        showVoucherEligibility(eligible) {
            if (eligible) {
                return 'Eligible for Active & Creative Kids <i class="fa fa-check-circle" aria-hidden="true"></i>';
            }

            return 'Not eligible for Active & Creative Kids <i class="fa fa-times-circle" aria-hidden="true"></i>';
        },
        showAttendeeEligibility(eligible) {
            if (eligible) {
                return 'No Attendee required <i class="fa fa-times-circle" aria-hidden="true"></i>';
            }

            return 'Attendee required <i class="fa fa-check-circle" aria-hidden="true"></i>';
        },
    },
    beforeCreate() {
        // this.$store.dispatch('user/userRequest');
        this.$store.dispatch("product/showCartState", false);

        this.$store
            .dispatch("product/getProductVenues")
            .then(() => {
                this.venues_list = this.venues;
            })
            .catch(err => {
                //error
            });

        // if(_.isEmpty(this.$store.getters['product/categories'])){
        this.$store
            .dispatch("product/getCategories", {'orig': this.$options.propsData.orig})
            .then(() => {
                if (!_.isNaN(parseInt(this.$route.query.category))) {
                    this.category = parseInt(this.$route.query.category);
                    this.updateCategoriesList(parseInt(this.$route.query.category));
                } else {
                    this.categories_list = this.categories;
                }
            })
            .catch(err => {
                //error
            });
        // }

        // if(_.isEmpty(this.$store.getters['product/products'])){
        this.$store
            .dispatch("product/getProducts", {'orig': this.$options.propsData.orig})
            .then(() => {
                if (!_.isNaN(parseInt(this.$route.query.category))) {
                    this.category = parseInt(this.$route.query.category);
                    this.updateProductsList(parseInt(this.$route.query.category));
                }
            })
            .catch(err => {
                //error
            });
        // }
    },
};
</script>

<style scoped>
::v-deep .v-dialog {
    margin: 4px !important;
}
.line-clamp-4 .v-list-item__subtitle {
    -webkit-line-clamp: 4 !important;
}
.v-list-item .v-list-item__content .product-overline {
    line-height: 1.3 !important;
}

.v-list-item .v-list-item__content .v-list-item__title.headline {
    font-size: 1.25rem !important;
    height: 65px !important;
    text-overflow: ellipsis !important;
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    white-space: normal !important;
}

.v-list-item .v-list-item__subtitle,
.v-list-item .v-list-item__title {
    line-height: 1.5 !important;
}
@media (max-width: 767px) {
    v-list-item .v-list-item__content .product-overline {
        line-height: 1.4 !important;
    }
    .v-list-item .v-list-item__content .v-list-item__title.headline {
        white-space: initial !important;
        font-size: 1rem !important;
        line-height: 1.3 !important;
        height: initial !important;
        -webkit-line-clamp: 3 !important;
    }
}
</style>
